import RGBColor from '../classes/rgb-color';
import helpers from '../helpers';

const xyz2rgb = ({ x, y, z, alpha }) => {
  let r;
  let g;
  let b;

  r = x * 3.2404542 + y * -1.5371385 + z * -0.4985314;
  g = x * -0.969266 + y * 1.8760108 + z * 0.041556;
  b = x * 0.0556434 + y * -0.2040259 + z * 1.0572252;

  // Assume sRGB
  r = r > 0.0031308 ? 1.055 * r ** (1.0 / 2.4) - 0.055 : r * 12.92;
  g = g > 0.0031308 ? 1.055 * g ** (1.0 / 2.4) - 0.055 : g * 12.92;
  b = b > 0.0031308 ? 1.055 * b ** (1.0 / 2.4) - 0.055 : b * 12.92;

  const { minMax } = helpers;
  r = minMax(0, r, 1);
  g = minMax(0, g, 1);
  b = minMax(0, b, 1);

  return new RGBColor(r, g, b, alpha);
};

export default xyz2rgb;
